import { applyMiddleware, createStore } from 'redux'
import promise from 'redux-promise'
import thunk from 'redux-thunk'
import analytics from './middleware/analytics'
import rootReducer from './reducers'

const middleware = [thunk, promise, analytics]

if (process.env.NODE_ENV === 'development') {
	// eslint-disable-next-line global-require
	const { logger } = require('redux-logger')
	middleware.push(logger)
}

export default function configureStore(initialState) {
	return createStore(
		rootReducer,
		applyMiddleware(...middleware),
		initialState,
	)
}



// WEBPACK FOOTER //
// ./src/redux/store.js